import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import {
  getFlightsResponseBody,
  isResponseContainFlightsBody,
  isFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import keyBy from 'lodash/keyBy';

import { mapAgents } from './agentsMapper';

import type {
  Action,
  MutationResponseAction,
  QueryResponseAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  Agent,
  AgentState,
  Agents,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightSearchResults/agents';

export type {
  AgentState,
  Agent,
  Agents,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightSearchResults/agents';

export const INITIAL_STATE: AgentState = {
  byId: {},
};

const byId = (state: Agents, action: MutationResponseAction | QueryResponseAction) => {
  switch (action.payload.type) {
    case RADAR_CREATE_SESSIONS:
    case RADAR_POLL: {
      if (
        isFlightsResponseError(action.payload.response) ||
        !isResponseContainFlightsBody(action.payload.response)
      ) {
        return state;
      }

      const flightsResponseBody = getFlightsResponseBody(action.payload.response);
      const agents = mapAgents(flightsResponseBody.agents || []);

      // THES-300: Preserve partner_messages after price refresh
      const agentsWithMessages = state
        ? agents.map((agent) => {
            if (state[agent.id] && state[agent.id]?.partner_messages) {
              return {
                ...agent,
                partner_messages: state[agent.id].partner_messages,
              };
            }
            return agent;
          })
        : agents;

      return { ...state, ...keyBy(agentsWithMessages, (agent) => agent.id) };
    }

    default:
      return state;
  }
};

export const agentsReducer = (state: AgentState = INITIAL_STATE, action: Action): AgentState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    default:
      return state;
  }
};

export const get = (state: AgentState, id: string): Agent | undefined => state.byId[id];
export const getAll = (state: AgentState): Record<string, Agent> => state.byId;
